var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShopping(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Type=Shopping"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5 22C4.45 22 3.97917 21.8042 3.5875 21.4125C3.19583 21.0208 3 20.55 3 20V8C3 7.45 3.19583 6.97917 3.5875 6.5875C3.97917 6.19583 4.45 6 5 6H7C7 4.61667 7.4875 3.4375 8.4625 2.4625C9.4375 1.4875 10.6167 1 12 1C13.3833 1 14.5625 1.4875 15.5375 2.4625C16.5125 3.4375 17 4.61667 17 6H19C19.55 6 20.0208 6.19583 20.4125 6.5875C20.8042 6.97917 21 7.45 21 8V20C21 20.55 20.8042 21.0208 20.4125 21.4125C20.0208 21.8042 19.55 22 19 22H5ZM9 6H15C15 5.16667 14.7083 4.45833 14.125 3.875C13.5417 3.29167 12.8333 3 12 3C11.1667 3 10.4583 3.29167 9.875 3.875C9.29167 4.45833 9 5.16667 9 6ZM11.975 14C13.2083 14 14.325 13.5917 15.325 12.775C16.325 11.9583 16.8167 11.0417 16.8 10.025C16.8 9.74167 16.7083 9.5 16.525 9.3C16.3417 9.1 16.1083 9 15.825 9C15.5917 9 15.3833 9.075 15.2 9.225C15.0167 9.375 14.8833 9.6 14.8 9.9C14.6167 10.5333 14.2583 11.0417 13.725 11.425C13.1917 11.8083 12.6083 12 11.975 12C11.3417 12 10.7542 11.8083 10.2125 11.425C9.67083 11.0417 9.31667 10.5333 9.15 9.9C9.06667 9.58333 8.94167 9.35417 8.775 9.2125C8.60833 9.07083 8.40833 9 8.175 9C7.89167 9 7.65417 9.1 7.4625 9.3C7.27083 9.5 7.175 9.74167 7.175 10.025C7.175 11.0417 7.66667 11.9583 8.65 12.775C9.63333 13.5917 10.7417 14 11.975 14Z",
    fill: "#152946"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopping);
export default __webpack_public_path__ + "static/media/shopping.36f8b19632f32ceb6c8dd26e552ad826.svg";
export { ForwardRef as ReactComponent };